//import React from 'react';
import React, { useEffect, useRef } from 'react';
import '../App.css';
import './about.css';
import './pricing.css';
import SEO from '../SEO';
import IntroVideo_about from '../images/purple_straight_abstract2.mp4';
import VideoComponent from './VideoComponent.js';
import BGwordanimation4 from './BGwordanimation4.js';
//import Purple_poly from '../images/pruple_line_field__small.mp4'; 
import { useScrollBehavior } from './useScrollBehavior.js';
//import { useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import FAQModule from './faq_module.js';
import Footer from './footer.js'


const Pricing = () => {

 useScrollBehavior();

  const title = "Pricing | Yokai Software";
  const description = "View Yokai Software pricing for web design, web development, growth marketing, AI chatbot systems, and ongoing digital support.";
  const canonical = "https://yokaisoftware.com/pricing";
  const image = "https://yokaisoftware.com/yokai_apple_touch_icon2.png";


  const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://yokaisoftware.com/#organization",
      name: "Yokai Software",
      url: "https://yokaisoftware.com/",
      logo: "https://yokaisoftware.com/yokai_apple_touch_icon2.png",
      description:
        "Yokai Software provides web design, web development, growth marketing, AI chatbot systems, and digital solutions for businesses."
    },
    {
      "@type": "WebPage",
      "@id": "https://yokaisoftware.com/pricing#webpage",
      url: "https://yokaisoftware.com/pricing",
      name: "Pricing | Yokai Software",
      description:
        "View Yokai Software pricing for web design, web development, growth marketing, AI chatbot systems, and ongoing digital support.",
      isPartOf: {
        "@id": "https://yokaisoftware.com/#website"
      },
      about: {
        "@id": "https://yokaisoftware.com/#organization"
      }
    },

    // 👇 ADD THIS
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What kind of businesses is this best for?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "This works best for service businesses, local businesses, and companies that need a stronger website, SEO support, lead capture, or a more structured digital presence."
          }
        },
        {
          "@type": "Question",
          "name": "Do you only build websites, or do you handle strategy too?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We handle more than visual design, including website structure, SEO, conversion strategy, and digital planning aligned with business goals."
          }
        },
        {
          "@type": "Question",
          "name": "Do you offer ongoing support after launch?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Ongoing support includes updates, technical fixes, SEO improvements, and continuous optimization as your business grows."
          }
        },
        {
          "@type": "Question",
          "name": "Can you build AI or chatbot features into a website?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. We build chatbot systems, lead qualification workflows, and AI-driven automation designed to improve conversions and streamline operations."
          }
        }
      ]
    }
  ]
};

  const stickyRef3 = useRef(null);
  const overlayRef3 = useRef(null);
  const stickyRef5 = useRef(null);
  const overlayRef5 = useRef(null);
  const moduleChatbotPackagesRef = useRef(null);
  const service_moduleFour_pricingRef =useRef(null);
  const service_moduleSix_pricingRef =useRef(null);
	
  



  

useEffect(() => {
  const handleScroll10 = () => {
    const pairs = [
      { sticky: stickyRef3.current, overlay: overlayRef3.current },
      { sticky: stickyRef5.current, overlay: overlayRef5.current },
    ];

    for (const { sticky, overlay } of pairs) {
      if (!sticky || !overlay) continue;

      const stickyRect = sticky.getBoundingClientRect();
      const overlayRect = overlay.getBoundingClientRect();

      if (stickyRect.top <= 0 && stickyRect.bottom > overlayRect.height) {
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        // Optional: lock width while fixed so it doesn't shrink/expand
        // overlay.style.width = `${sticky.offsetWidth}px`;
      } else if (stickyRect.bottom <= overlayRect.height) {
        overlay.style.position = 'absolute';
        overlay.style.top = `${stickyRect.height - overlayRect.height}px`;
      } else {
        overlay.style.position = 'absolute';
        overlay.style.top = '0';
      }
    }
  };

  window.addEventListener('scroll', handleScroll10, { passive: true });
  handleScroll10(); // set initial positions on mount

  return () => window.removeEventListener('scroll', handleScroll10);
}, []);

/*useEffect(() => {
    if (!location.hash) return;

    
    requestAnimationFrame(() => {
      const el = document.querySelector(location.hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, [location.hash]);*/

  useEffect(() => {
		const hash = window.location.hash.substring(1);
	
		if (hash === 'moduleChatbotPackages' && moduleChatbotPackagesRef.current) {
		  scrollToElement(moduleChatbotPackagesRef.current);
		} else if (hash === 'service_moduleFour_pricing' && service_moduleFour_pricingRef.current) {
		  scrollToElement(service_moduleFour_pricingRef.current);
	  } else if (hash === 'service_moduleSix_pricing' && service_moduleSix_pricingRef.current) {
		  scrollToElement(service_moduleSix_pricingRef.current);
		  }
	  }, []);
	
	  const scrollToElement = (element) => {
		const elementRect = element.getBoundingClientRect();
		const offsetTop = elementRect.top + window.scrollY;
		const windowHeight = window.innerHeight;
		const elementHeight = elementRect.height;
		const scrollToY = offsetTop - (windowHeight - elementHeight) / 2;
		//const scrollToY = offsetTop - (windowHeight - elementRect.height) / 2;
		window.scrollTo({ top: scrollToY, behavior: 'smooth' });
	  };
const letterAnimation = {
		hidden: { opacity: 0 },
		visible: (i) => ({
		  opacity: 1,
		  transition: {
			delay: i * 0.08,
			duration: 0.5,
		  },
		}),
	  };
  
const renderAnimatedLettersByWord = (text, isInView) => {
  const words = text.split(' ');
  let k = 0;
  return words.map((word, wi) => (
    <span className="wordWrap" key={wi}>
      {word.split('').map((char, ci) => (
        <motion.span
          key={`${wi}-${ci}`}
          custom={k++}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={letterAnimation}
          className="char"
        >
          {char}
        </motion.span>
      ))}
      {/* keep a real space so line can break BETWEEN words */}
      {wi < words.length - 1 ? ' ' : null}
    </span>
  ));
};

const pricingFaqItems = [
  {
    question: 'How is your pricing structured?',
    answer:
      'We offer both monthly support models and project-based pricing. Monthly plans are best for businesses that need ongoing development, SEO, or marketing. Project pricing is better for one-time builds or clearly defined work.'
  },
  {
    question: 'What determines the final cost of a project?',
    answer:
      'Cost depends on scope, features, integrations, and whether ongoing work like SEO, marketing, or automation is included. A simple site costs less than a system with lead funnels, integrations, and growth infrastructure.'
  },
  {
    question: 'Is there a minimum commitment for monthly plans?',
    answer:
      'Most monthly plans are structured for ongoing work, but we keep commitments flexible. The goal is long-term results, not locking you into something that does not make sense for your business.'
  },
  {
    question: 'What do I actually get with monthly support?',
    answer:
      'Monthly support includes development updates, design changes, SEO work, performance improvements, and ongoing optimization. Instead of a static website, your system continues to evolve and improve over time.'
  },
  {
    question: 'Can I start with a project and move into a monthly plan later?',
    answer:
      'Yes. Many businesses start with a build and transition into ongoing support once the site is live. This allows you to scale your investment as your business grows.'
  },
  {
    question: 'Do you work with smaller budgets or startups?',
    answer:
      'Yes, but the approach depends on what will actually move the business forward. In some cases, a smaller focused build is better than spreading resources too thin across multiple services.'
  },
  
  {
    question: 'What happens if I need changes after the project is finished?',
    answer:
      'You can request additional work as needed or move into a monthly support plan. Most clients choose ongoing support so improvements can be made continuously without starting from scratch.'
  }
];


  return (
    <div className="main_pricing-container">

      <SEO
      title={title}
      description={description}
      canonical={canonical}
      image={image}
      schema={schema}
    />
       {/*<div className="background-image"></div>*/}
     <VideoComponent  videoSrc={IntroVideo_about} />
       <div className='module_service_pricing' id='service_moduleOne_pricing'>
              
              <div id='pricing_heading1'>
                  <h1>Transparent Pricing. Structured Growth.</h1>
                  <br></br>
                  <br></br>
                  <h3>Clear monthly investment across web development, marketing, AI automation,
                    and consulting</h3>
              </div>
       </div>
       <div className='module_service_pricing' id='service_moduleTwo_pricing'>
        <div id='mod2_div__pricing'>
          <h1>Choose the Level of Execution Your Business Needs</h1> 
          <h3>Start with foundation. Scale with systems</h3>
        </div>
        <div id='mod2_div__pricing2'>  
            <h3>
                Not every business requires the same level of digital infrastructure. 
                Some need a strong foundation. Others require advanced marketing deployment 
                and automation. These pricing tiers are structured to meet you where 
                you are — while building systems that support long term expansion. 
                Each plan represents real implementation designed to move your business forward.
          </h3>
        </div>
       </div>
       {/*<div class="svg-wrapper">
        <svg id='about_div1'  viewBox="0 0 94 94" preserveAspectRatio="xMidYMid meet">
          <rect x="-54" y="-5" width="200" height="100" rx="12" fill="none" stroke="#5112a3" stroke-width="15" />
            <foreignObject className="cutout-container">

              <div className='cutout'>

                  <p>This is space material </p>

              </div>

            </foreignObject>
        </svg>
      </div>*/}

      <div className='module_service_pricing' id='service_moduleThree_about'>
        <div id='mod3_div__about'>
          <h1>Choose the Structure That Supports Your Expansion</h1>
          <h3>Strategic Execution with Built-In Flexibility.</h3>
          <p>We provide scalable digital infrastructure through adaptable engagement models. 
            From focused projects to ongoing strategic oversight, our approach ensures your 
            development and marketing systems evolve in step with your business.</p>
        </div>
      </div>

      <div className='module_service_pricing' id='service_moduleFour_pricing' ref={service_moduleFour_pricingRef}>
        <div id='mod4_about_div1'>
          <div   className="sticky-element-container3 ">
            <div  ref={stickyRef3}className="background-div3">
              <div ref={overlayRef3} className="overlay-container3">
                <div id='about_overlayText3'>
                  <br></br>
                  <br></br>
                  <br></br>
                  <h1>Subscription Based</h1>
                    <p>Partner with us on a monthly basis and unlock the flexibility to scale. 
                    Whether you need end-to-end web, design, and marketing services or simply 
                    extra support where it counts, we adapt to your needs..</p>
                    <ul>
                      <li>Predictable Monthly Investment</li>
                      <li>Integrated Web, Design & Marketing</li>
                      <li>Ongoing Website Improvements</li>
                      <li>Proactive Maintenance & Monitoring</li>
                      <li>Continuous Design & Development Support</li>
                      <li>Flexible Marketing Execution</li>
                    </ul>
                </div>
        
              </div>
           </div>
         
          </div>
            <div id='mod4_about_div2'>
                <div id='pricing_pic_div1'></div>
            </div>
        </div>
    
   </div>

   <div className="module" id="modulePackages2">

  <div id="packages_container2">

    {/* 1 — Extra Consulting */}
    <div className="package_box2">
      <h1>EXTRA CONSULTING & EXECUTION</h1>
      <h2>$2,000</h2>
      <h3>Per Month</h3>

      <ul>
        <li>Everything in Full Plan</li>
        <li>Multiple Websites</li>
        <li>Large Marketing Campaigns</li>
        <li>Tech Stack Builds for Business</li>
      </ul>

      <Link to="/ContactPage" className="package_btn" onClick={() => window.scrollTo(0, 0)}>
        Message Us
      </Link>
    </div>

    {/* 2 — Full Plan */}
    <div className="package_box2 featured_box">
      <h1>FULL PLAN</h1>
      <h2>$1,000</h2>
      <h3>Per Month</h3>

      <ul>
        <li>Full Website Build</li>
        <li>Analytics Suite</li>
        <li>SEO & Google Ranking</li>
        <li>Social Media Marketing</li>
        
      </ul>

      <Link to="/ContactPage" className="package_btn" onClick={() => window.scrollTo(0, 0)}>
        Get Started
      </Link>
    </div>

    {/* 3 — Custom */}
    <div className="package_box2">
      <h1>LAUNCH PACKAGE + MONTHLY SUPPORT</h1>
      <h2>$X,XXX Setup</h2>
      <h3>$XXX / Month</h3>

      <ul>
        <li>Professionally Built Website</li>
        <li>Mobile-Optimized Design</li>
        <li>Hosting & Domain Included</li>
        <li>Monthly Maintenance & Updates</li>
      </ul>
      <p>Does not include ongoing SEO campaigns.</p>

      <Link to="/ContactPage" className="package_btn" onClick={() => window.scrollTo(0, 0)}>
        Message Us
      </Link>
    </div>

  </div>

</div>
   <div className='module_service_about' id='service_moduleFive_about'>
      <div id='spacer_div_parralx'>
            <h1>Built With Purpose</h1>
          <h3>Strategy Before Execution. Always.</h3>
          <p>Every business operates under different constraints, goals, and competitive 
            pressures. We design and build digital systems around your specific objectives 
            not recycled templates or generic playbooks. The result is infrastructure that 
            supports growth, not just aesthetics.</p>
      </div> 
  </div> 
  <div className='module_service_about' id='service_moduleSix_pricing' ref={service_moduleSix_pricingRef}>
        <div id='mod6_about_div1'>
           <div id='mod6_about_div2'>
                <div id='pricing_pic_div1_m6'></div>
            </div>
          <div   className="sticky-element-container3_m6 ">
            <div  ref={stickyRef5}className="background-div3_m6">
              <div ref={overlayRef5} className="overlay-container3_m6">
                <div id='about_overlayText3_m6'>
                  <br></br>
                  <br></br>
                  <br></br>
                  <h1>Project Based</h1>
                    <p>From complete site builds to targeted feature development, 
                      we deliver structured projects aligned with your objectives.</p>
                      <ul>
                      <li>Goal-Oriented Project Planning</li>
                      <li>Defined Budget</li>
                      <li>End-to-End Development</li>
                      <li>UX/UI Design Included</li>
                      <li>Deployment & Go-Live Support</li>
                      <li>Optional Ongoing Support Add-On</li>
                    </ul>
                </div>
        
              </div>
           </div>
         
          </div>
           
        </div>
    
   </div>
  

   <div className="module" id="modulePackages">
  				<div id="packages_container">
					<div className="package_box">
      					<h1>Starter</h1>
      					<h2>$699 <span>$899</span></h2>
							<ul>
        						<li>3 Page Website</li>
        						<li>3 Banner Design</li>
        						<li>5 Stock Photos</li>
        						<li>1 Slider Banner</li>
        						<li>FREE Google Friendly Sitemap</li>
        						<li>Complete W3C Certified HTML</li>
                    <li>Technical SEO</li>
        						<li>Social Media Integration</li>
        						<li>100% Ownership Rights</li>
        						<li>100% Unique Design Guarantee</li>
      						</ul>
    				</div>
					<div className="package_box">
      					<h1>Professional</h1>
      					<h2>$1,299 <span>$1,599</span></h2>
      						<ul>
        						<li>5 Unique Pages Website</li>
        						<li>CMS / Admin Panel Support</li>
        						<li>8 Stock Images</li>
        						<li>5 Banner Designs</li>
        						<li>1 Slider Banner</li>
        						<li>FREE Google Friendly Sitemap</li>
        						<li>Complete W3C Certified HTML</li>
                    <li>Technical SEO</li>
        						<li>Social Media Integration</li>
        						<li>Complete Deployment</li>
        						<li>100% Ownership Rights</li>
        						<li>100% Unique Design Guarantee</li>
      						</ul>
    				</div>
					<div className="package_box">
      					<h1>Business Web</h1>
      					<h2>$1,999 <span>$2,199</span></h2>
							<ul>
        						<li>15 Unique Pages Website</li>
        						<li>CMS / Admin Panel Support</li>
        						<li>Unlimited Revisions</li>
        						<li>8 Stock Images</li>
        						<li>5 Banner Designs</li>
        						<li>1 Slider Banner</li>
        						<li>Online Payment Integration (Optional)</li>
        						<li>Appointment / Scheduling Integration (Optional)</li>
       							<li>Complete W3C Certified HTML</li>
                    <li>Technical SEO</li>
        						<li>Complete Deployment</li>
        						<li>Social Media Integration</li>
        						<li>Mobile Responsive Website</li>
        						<li>Dedicated Account Manager</li>
        						<li>100% Unique Design Guarantee</li>
      						</ul>
    				</div>
					<div className="package_box">
      					<h1>Startup E-Commerce</h1>
      					<h2>$2,999 <span>$3,199</span></h2>
							<ul>
        						<li>Up to 15 Unique Pages Website</li>
        						<li>Dynamic Website</li>
        						<li>CMS</li>
        						<li>Mobile Responsive</li>
                    <li>Technical SEO</li>
                    <li>Social Media Integration</li>
        						<li>Up To 100 Products</li>
        						<li>Unlimited Categories</li>
        						<li>Shopping Cart Integration</li>
        						<li>Payment Integration</li>
        						<li>Sales & Inventory Management</li>
        						<li>Free Google Friendly Sitemap</li>
        						<li>Complete Deployment</li>
        						<li>Dedicated Account Manager</li>
        						<li>100% Ownership Rights</li>
        						<li>100% Unique Design Guarantee</li>
      						</ul>
   					 </div>
					<div className="package_box">
      					<h1>Business E-Commerce</h1>
      					<h2>$9,999 <span>$10,199</span></h2>
							<ul>
        						<li>Unlimited Pages</li>
        						<li>Unlimited Categories</li>
        						<li>Unlimited Revisions</li>
        						<li>Full Shopping Cart & Checkout</li>
        						<li>Sales & Inventory Management</li>
        						<li>CMS</li>
        						<li>Multi-lingual</li>
        						<li>Search Bar</li>
        						<li>Mobile Responsive</li>
                    <li>Technical SEO</li>
                    <li>Social Media Integration</li>
        						<li>Free Google Friendly Sitemap</li>
        						<li>Search Engine Submission</li>
        						<li>Complete Deployment</li>
        						<li>Dedicated Account Manager</li>
        						<li>100% Ownership Rights</li>
        						<li>100% Unique Design Guarantee</li>
      						</ul>
   					 </div>
					 <div className="package_box">
      					<h1>Enterprise</h1>
      					<h2>$9,999 <span>$10,199</span></h2>
							<ul>
        						<li>Unlimited Pages Website</li>
        						<li>Custom High-End Design</li>
        						<li>Custom React Development</li>
        						<li>Unlimited Revisions</li>
        						<li>CMS</li>
        						<li>Online Payment Integration (Optional)</li>
        						<li>Multi Lingual (Optional)</li>
        						<li>Mobile Responsive</li>
                    <li>Technical SEO</li>
                    <li>Social Media Integration</li>
        						<li>Free Google Friendly Sitemap</li>
        						<li>Search Engine Submission</li>
        						<li>Complete Deployment</li>
        						<li>Dedicated Account Manager</li>
        						<li>100% Ownership Rights</li>
        						<li>100% Unique Design Guarantee</li>
      						</ul>	
    				</div>

  				</div>
			</div>

 

   <div className='module_service_about' id='service_moduleSeven_about'>
      <div id='spacer_div_parralx2'>
           <BGwordanimation4/>
      </div> 
  </div>  

<div className="module" id="moduleChatbotPackages" ref={moduleChatbotPackagesRef}>
  <div id='moduleChatbotPackages_title'>
          <h1>AI Chat Systems Built for Growth</h1>
          <h3>Turn Website Traffic Into Structured Opportunities.</h3>
          <p>From basic lead capture to advanced routing and CRM integration, 
            our chatbot tiers are designed to scale with your business and 
            operational complexity.</p>
      </div> 
  <div id="chatbot_packages_container">

    {/* 1 — Starter */}
    <div className="package_box chatbot_box">
      <h1>CHATBOT STARTER</h1>
      <h2>$399</h2>
      <h3>Per Month</h3>

      <ul>
        <li>Chatbot Widget Installed on Your Site</li>
        <li>FAQ / Services Knowledge Base (up to ~15 pages)</li>
        <li>Lead Capture (name, email, phone)</li>
        <li>Basic Conversation Flows</li>
        <li>Monthly Updates (1 refresh)</li>
        <li>Email Notifications for New Leads</li>
      </ul>

      <Link to="/ContactPage" className="package_btn" onClick={() => window.scrollTo(0, 0)}>
        Get Started
      </Link>
    </div>

    {/* 2 — Growth (Featured) */}
    <div className="package_box chatbot_box featured_box">
      <h1>CHATBOT GROWTH</h1>
      <h2>$799</h2>
      <h3>Per Month</h3>

      <ul>
        <li>Everything in Starter</li>
        <li>Expanded Knowledge Base (up to ~60 pages)</li>
        <li>Lead Qualification Questions + Routing</li>
        <li>Calendly / Scheduling Integration</li>
        <li>Analytics: Conversations, Leads, Top Questions</li>
        <li>Monthly Optimization (2 refreshes)</li>
        <li>Custom Branding + Tone</li>
      </ul>

      <Link to="/ContactPage" className="package_btn" onClick={() => window.scrollTo(0, 0)}>
        Get Started
      </Link>
    </div>

    {/* 3 — Pro / Multi-Location */}
    <div className="package_box chatbot_box">
      <h1>CHATBOT PRO</h1>
      <h2>$1,499</h2>
      <h3>Per Month</h3>

      <ul>
        <li>Everything in Growth</li>
        <li>Multi-Location / Multi-Service Routing</li>
        <li>CRM Sync (HubSpot / Zoho / Sheets / Zapier)</li>
        <li>Outbound Follow-ups (email/SMS workflow ready)</li>
        <li>Intent Tags + Lead Scoring (basic)</li>
        <li>Monthly Optimization (weekly refreshes)</li>
        <li>Priority Support</li>
      </ul>

      <Link to="/ContactPage" className="package_btn" onClick={() => window.scrollTo(0, 0)}>
        Message Us
      </Link>
    </div>

  </div>
</div>
 <div className="module" id="moduleFAQ">
          <FAQModule renderAnimatedLettersByWord={renderAnimatedLettersByWord} faqItems={pricingFaqItems}/>
  </div>
 
    <Footer/>
   
    </div>
  );
}

export default Pricing;


